import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import "./index.css";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const user = userCredential.user;

      console.log("Logged in:", user);

      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.log(error.message);
      setError("Invalid Email or Password");
    }
  };

  const { user } = useAuth();
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <div className="login-container">
      <form className="login-form" onSubmit={(event) => handleLogin(event)}>
        <h1 className="login-main-heading">Login</h1>

        <label>
          Email
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>

        {error && <p className="login-error">{error}</p>}

        <button class="login-button" type="submit">
          Login
        </button>

        <p className="go-for-register-instead">
          Don't have an account?
          <span className="register-link" onClick={() => navigate("/register")}>
            {" "}
            Register
          </span>
        </p>
      </form>
    </div>
  );
};

export default Login;
